import { render } from "./SingleProductList.vue?vue&type=template&id=767610bc&scoped=true&ts=true"
import script from "./SingleProductList.vue?vue&type=script&lang=ts"
export * from "./SingleProductList.vue?vue&type=script&lang=ts"

import "./SingleProductList.vue?vue&type=style&index=0&id=767610bc&lang=scss&scoped=true"
import "./SingleProductList.vue?vue&type=style&index=1&id=767610bc&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767610bc"]])

export default __exports__